<template>
  <div class="org-name">
    <template v-if="isIdValid">
      <span v-if="showContent" v-for="(org, index) in orgs" :key="index">
        <span v-if="index > 0">&nbsp;>&nbsp;</span>
        <template v-if="orgLinkName">
          <router-link :to="{ name: orgLinkName, params: { id: org.getId() } }" class="org-name__link">
            {{ org.getName() }}
          </router-link>
        </template>
        <template v-else>{{ org.getName() }}</template>
      </span>
    </template>
    <template v-else>
      {{ $t('labels.no_data') }}
    </template>
  </div>
</template>
<script>
  export default {
    name: 'orgName',
    props: {
      orgId: {
        type: String,
        default: ''
      },
      showParent: {
        type: Boolean,
        default: false
      },
      asLink: {
        type: Boolean,
        default: false
      },
      orgLinkName: String
    },
    data () {
      return {
        orgs: [],
        showContent: false,
        isIdValid: true,
        iterateConter: 0
      }
    },
    methods: {
      async loadOrg (parentId) {
        try {
          const MAX_ITERATE = 10;
          this.iterateConter++;
          let id = parentId || this.orgId
          let regexp = /^[a-f0-9]{24}$/;

          if (!regexp.test(id)) {
            this.isIdValid = false;
            return false;
          }

          let org = await this.$store.dispatch('orgs/loadOrg', id)
          this.orgs.push(org);
          let parent = org.getParentId();
          if (this.iterateConter >= MAX_ITERATE) {
            console.error(`DepName infinite looping! MAX_ITERATE = ${MAX_ITERATE}, this iterate number = ${this.iterateConter}`);
            this.isIdValid = false;
            return false;
          } else if (this.showParent && parent) {
            this.loadOrg(parent)
          } else {
            this.orgs.reverse();
            this.showContent = true
          }
        } catch (error) {
          console.error('OrgName -> loadOrg', error)
          this.isIdValid = false;
        }
      },
      update () {
        this.orgs = []
        this.showContent = false
        this.isIdValid = true
        this.loadOrg();
      }
    },
    mounted () {
      this.loadOrg()
    }
  }
</script>
<style lang="scss">
@import 'src/assets/sass/paper/variables';
.org-name {
  display: inline-block;

  &__link {
    color: inherit;
  }
}
</style>